import React from "react";

const Footer = () => (

<div className="footer">
            
<footer className="page-footer font-small special-color-dark ">

  <div className="container">

    <ul className="list-unstyled list-inline text-center">
      <li className="list-inline-item">
       <a className="btn-floating btn-fb " href="https://www.facebook.com/Stefan.Kehayov.MLG/" > 
        <h6>Facebook: 
          <i className="fab fa-facebook-f" alt="Facebook"> </i>
       
        </h6>
         </a>
      </li>
      <li className="list-inline-item">
      <a className="btn-floating btn-tw " href="https://twitter.com/Stefan__Kehayov" >
      <h6>Twitter: 
          <i className="fab fa-twitter" alt="Twitter"> </i> 
        
        </h6>
        </a>
      </li>
      
      <li className="list-inline-item">
      <a className="btn-floating btn-li " href="https://www.linkedin.com/in/stefan-kehayov-1743861b9/"  >
      <h6>LinkedIn: 
          <i className="fab fa-linkedin-in" alt="LinkedIn" > </i>
       
        </h6>
         </a>
      </li>


      <li className="list-inline-item">
      <a className="btn-floating btn-dribbble " href="https://github.com/StefanKehayov" > 
      <h6>GitHub: 
          <i className="fab fa-github"> </i>  
       
        </h6>
         </a>

      </li>
    </ul>
    

  </div>
 

  
  <div className="footer-copyright text-center">© 2021 Copyright
  </div>
  

</footer>
        </div>

);

export default Footer;


